// extracted by mini-css-extract-plugin
export default {"text-align-left":"text-align-left__DmGeB","icon-class":"icon-class__l2HL4","d-inline":"d-inline__tvumA","mr-6":"mr-6__dOWCD","space":"space__suL0C","card":"card__yMcQR"};